import { z } from 'zod';
import { emailSchema, passwordSchema, userNameSchema } from './schemas';

export const registerSchema = z.object({
  name: userNameSchema,
  email: emailSchema,
  confirmEmail: z.string().min(1, 'Please confirm your email'),
  password: passwordSchema,
  confirmPassword: z.string().min(1, 'Please confirm your password'),
  acknowledgements: z.literal(true, {
    message: 'You must acknowledge the Terms of Use and Privacy Policy',
  }),
}).refine((data) => data.email.trim().toLowerCase() === data.confirmEmail.trim().toLowerCase(), {
  message: "Emails don't match",
  path: ['confirmEmail'],
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ['confirmPassword'],
});

export type RegisterInput = z.infer<typeof registerSchema>;
